import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { ImageWithLabel } from "../components"
import classnames from "classnames"

// image gallery is only use for querying images in src folder
// not for static images!!!

const BrWrapper = ({ children }) => {
  return (
    <>
      {children}
      <br />
    </>
  )
}

const ImageGallery = ({
  imageArr = [],
  mode = "type2",
  children,
  className,
}) => {
  const Images = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          relativeDirectory: { regex: "/^images/" }
          extension: { regex: "/(jpg)|(png)|(jpeg)/" }
        }
      ) {
        edges {
          node {
            ...fragmentsFluidImage
            relativePath
            relativeDirectory
          }
        }
      }
    }
  `)
  const queryImageMap = Images.allFile.edges
    .map(file => file.node)
    .reduce((acc, cur) => {
      return { ...acc, [cur.relativePath]: cur }
    }, {})

  // console.log("ImageGallery children", children)
  // console.log("!!!!!!", queryImageMap[imageArr[0].path])

  switch (imageArr.length) {
    case 1:
      if (children) {
        return (
          <BrWrapper>
            <div
              className={classnames(
                {
                  "image-gallery": true,
                  [`image-gallery--type${imageArr.length}`]: !!mode,
                  "image-gallery--with-text": true,
                },
                className
              )}
            >
              <div>{children}</div>
              <div>
                {imageArr.map((img, index) => (
                  <ImageWithLabel
                    key={index}
                    fluidImage={queryImageMap[img.path].childImageSharp.fluid}
                    imgAlt={img.imgAlt}
                    imgTitle={img.imgTitle}
                    label={img.label}
                  ></ImageWithLabel>
                ))}
              </div>
            </div>
          </BrWrapper>
        )
      }
    case 2:
      return (
        <BrWrapper>
          <div
            className={classnames(
              {
                "image-gallery": true,
                [`image-gallery--type${imageArr.length}`]: !!mode,
              },
              className
            )}
          >
            {imageArr.map((img, index) => (
              <ImageWithLabel
                key={index}
                fluidImage={queryImageMap[img.path].childImageSharp.fluid}
                imgAlt={img.imgAlt}
                imgTitle={img.imgTitle}
                label={img.label}
              ></ImageWithLabel>
            ))}
          </div>
        </BrWrapper>
      )
    case 3:
      return (
        <BrWrapper>
          <div
            className={classnames(
              {
                "image-gallery": true,
                [`image-gallery--type${imageArr.length}`]: !!mode,
              },
              className
            )}
          >
            <div>
              {imageArr.slice(0, 1).map((img, index) => (
                <ImageWithLabel
                  key={index}
                  fluidImage={queryImageMap[img.path].childImageSharp.fluid}
                  imgAlt={img.imgAlt}
                  imgTitle={img.imgTitle}
                  label={img.label}
                ></ImageWithLabel>
              ))}
            </div>
            <div>
              {imageArr.slice(1).map((img, index) => (
                <ImageWithLabel
                  key={index}
                  fluidImage={queryImageMap[img.path].childImageSharp.fluid}
                  imgAlt={img.imgAlt}
                  imgTitle={img.imgTitle}
                  label={img.label}
                ></ImageWithLabel>
              ))}
            </div>
          </div>
        </BrWrapper>
      )
    default:
      return (
        <div
          className={classnames(
            {
              "image-gallery": true,
              [`image-gallery--${mode}`]: !!mode,
            },
            className
          )}
        >
          {imageArr.map((img, index) => (
            <ImageWithLabel
              key={index}
              fluidImage={queryImageMap[img.path].childImageSharp.fluid}
              imgAlt={img.imgAlt}
              imgTitle={img.imgTitle}
              label={img.label}
            ></ImageWithLabel>
          ))}
        </div>
      )
  }
}

export default ImageGallery
